import * as React from 'react'
import { cn } from '#app/utils/misc.tsx'
import { Icon, type IconName } from './icon.tsx'

export interface ProgressBarProps
	extends React.ComponentPropsWithoutRef<'div'> {
	/**
	 * Progress percentage (0-100)
	 */
	progress: number
	/**
	 * Icon to display at the progress indicator
	 */
	icon?: IconName
	/**
	 * Icon size in pixels (default: 18)
	 */
	iconSize?: number
}

const ProgressBar = React.forwardRef<HTMLDivElement, ProgressBarProps>(
	(
		{ className, progress = 0, icon = 'car-04', iconSize = 18, ...props },
		ref,
	) => {
		// Clamp progress between 0 and 100
		const clampedProgress = Math.min(Math.max(progress, 0), 100)

		return (
			<div
				ref={ref}
				className={cn('flex w-full items-center gap-3', className)}
				{...props}
			>
				<div className="relative h-2 flex-1 overflow-visible rounded-lg bg-neutral-100">
					{/* Progress indicator */}
					<div
						className="absolute top-[-9px] left-0 flex items-center pr-3 transition-all duration-700 ease-out"
						style={{ width: `${clampedProgress}%` }}
					>
						<div className="mr-[-12px] h-2 flex-1 rounded bg-green-500" />
						<div className="relative z-10 mr-[-12px] flex items-center justify-center rounded-full bg-green-500 p-1 shadow-[0px_2px_4px_0px_rgba(217,217,217,1)]">
							<Icon
								name={icon}
								className="fill-white text-white"
								style={{ width: iconSize, height: iconSize }}
							/>
						</div>
					</div>
				</div>
			</div>
		)
	},
)

ProgressBar.displayName = 'ProgressBar'

export { ProgressBar }
